export default __webpack_public_path__ + "static/media/img16.9e040f91.JPG";